// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-progress-circle {
  position: relative;
  display: inline-block;
}

.download-progress-circle svg {
  display: block;
}

.download-progress-circle .progress-percent,
.download-progress-circle .progress-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
  font-weight: 700;
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  pointer-events: none;
  user-select: none;
}

.download-progress-circle .progress-loading {
  font-size: 14px;
}

/* Spin animation for indeterminate spinner */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.download-progress-circle svg.indeterminate circle:last-child {
  animation: spin 1s linear infinite;
  transform-origin: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/Common/DownloadProgressCircle.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B","sourcesContent":[".download-progress-circle {\n  position: relative;\n  display: inline-block;\n}\n\n.download-progress-circle svg {\n  display: block;\n}\n\n.download-progress-circle .progress-percent,\n.download-progress-circle .progress-loading {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 12px;\n  font-weight: 700;\n  color: white;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n  pointer-events: none;\n  user-select: none;\n}\n\n.download-progress-circle .progress-loading {\n  font-size: 14px;\n}\n\n/* Spin animation for indeterminate spinner */\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.download-progress-circle svg.indeterminate circle:last-child {\n  animation: spin 1s linear infinite;\n  transform-origin: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
